// TanStack Query hooks for the console app-user endpoints (/api/admin/users).

import { useInfiniteQuery } from "@tanstack/react-query";
import { apiFetch } from "./client";
import type { AppUserPage } from "./types";

// The customer backend owns the users; the server relays its cursor pages (ascending by uid).
export function useAppUsers() {
  return useInfiniteQuery({
    queryKey: ["app-users"],
    initialPageParam: null as string | null,
    queryFn: ({ pageParam }) =>
      apiFetch<AppUserPage>(
        pageParam ? `/api/admin/users?cursor=${encodeURIComponent(pageParam)}` : "/api/admin/users",
      ),
    getNextPageParam: (last) => last.next_cursor,
  });
}
